export default __webpack_public_path__ + "static/media/magician.c27a675e.png";